import { inject, Injectable, InjectionToken } from '@angular/core';

export interface LDataTypeConfig {
	forceMock?: boolean;
}

export const LDATA_TYPE_CONFIG = new InjectionToken<LDataTypeConfig>('ldatatype.config', {
	providedIn: 'root',
	factory: () => ({ forceMock: false }),
});

export type LDataType = 'mock' | 'test' | 'prod';

@Injectable({
	providedIn: 'root',
})
export class LDataTypeService {
	private readonly config = inject(LDATA_TYPE_CONFIG);

	public getDataType(): LDataType {
		if (this.config.forceMock) {
			return 'mock';
		}

		const queryDataType =
			(new URLSearchParams(window.location.search).get('ldatatype') || '').toLowerCase();

		if (queryDataType === 'mock' || queryDataType === 'test') {
			return queryDataType;
		}

		return 'prod';
	}

	public isMock(): boolean {
		return this.getDataType() === 'mock';
	}
}